export default {
	bucketURL: 'https://storage.googleapis.com/webbyreport-811f9.appspot.com/',
	rootURL: 'https://watch.webbyawards.com',
	endpoint: 'https://us-central1-webbyreport-811f9.cloudfunctions.net', // 'https://webbyreport-811f9.uc.r.appspot.com'
	// endpoint: 'http://localhost:8080'
}
